module.exports = __webpack_public_path__ + "static/media/52708369_2453001788108331_6101432683886280704_o.5729693b.jpg";